import React from "react";
import { Icon } from "../../../_components";

export function FAQs() {
  return (
    <div className="chronos-help-topic-page chronos-faqs-topic">
      <h3 className="chronos-topic-header">Why can't I rename seconds?</h3>
      <p>
        Since TrueTime uses seconds as the common unifying time unit, these
        cannot be re-named or configured (they always have a duration of 1).
        However, your minutes, hours, etc, can have completely customized
        durations. Click the Calendars Manager{" "}
        <Icon icon="far fa-calendar-edit fa-fw" /> &nbsp;on the right toolbar to
        edit them.
      </p>
      <h3 className="chronos-topic-header">
        Can I have a different Calendar for each Timeline?
      </h3>
      <p>Not yet, but this is planned for a future update!</p>
      <h3 className="chronos-topic-header">Can I name my days of the week?</h3>
      <p>Not yet, but this is planned for a future update!</p>
      <h3 className="chronos-topic-header">
        Can I create more lanes for my Timelines?
      </h3>
      <p>Not yet, but this is planned for a future update!</p>
      <h3 className="chronos-topic-header">
        Can I name the lanes in my Timeline?
      </h3>
      <p>Not yet, but this is planned for a future update!</p>
      <h3 className="chronos-topic-header">
        Can I import my Maps &amp; historical events from my world?
      </h3>
      <p>
        You cannot currently import historical events or maps from your world.
      </p>
    </div>
  );
}
